import type { IStringSchema } from '@ksyos/koi';
import { Koi } from '@ksyos/koi';

export function getTextInputStringSchema(allowNull = false, max = 10000): IStringSchema<any> {
    let stringSchema = Koi.string().max(max);
    if (allowNull) {
        stringSchema = stringSchema.allow(null);
    }

    return stringSchema;
}
